var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    zoomAndPan: "magnify",
    viewBox: "0 0 52.5 52.499999",
    height: 70,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#25d366",
    d: "M 42.011719 10.761719 C 33.074219 1.824219 18.773438 1.636719 10.0625 10.347656 C 2.417969 17.992188 1.628906 29.957031 7.605469 38.8125 L 3.53125 49.828125 L 14.179688 45.3125 C 23.011719 51.128906 34.84375 50.292969 42.425781 42.707031 C 51.132812 34 50.949219 19.699219 42.011719 10.761719 Z M 42.011719 10.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7deed",
    d: "M 37.03125 31.71875 C 39.121094 32.980469 39.53125 32.886719 39.53125 34.164062 C 39.53125 35.328125 36.800781 39.105469 33.714844 39.109375 C 29.195312 39.105469 24.257812 36.324219 20.378906 32.554688 C 16.605469 28.675781 13.824219 23.738281 13.824219 19.21875 C 13.824219 16.128906 17.601562 13.402344 18.769531 13.402344 C 20.046875 13.402344 19.953125 13.808594 21.214844 15.902344 C 21.914062 17.066406 23.578125 19.253906 23.265625 20.070312 C 22.8125 21.234375 20.074219 22.601562 20.074219 23.433594 C 20.078125 26.214844 26.71875 32.855469 29.496094 32.855469 C 30.328125 32.855469 31.695312 30.117188 32.859375 29.667969 C 33.675781 29.351562 35.867188 31.019531 37.03125 31.71875 Z M 37.03125 31.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b9c59e7143a33ef9fde0c50cfe08b774.svg";
export { ForwardRef as ReactComponent };